import { Component, OnInit, Input } from '@angular/core';
import { IxellAPIService, IProductV1, ProductType, ScaleSelect } from 'src/app/tools/api.service';
import { FormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ErrorService } from 'src/app/tools/error.service';
import { getImageUrl } from './image-orientation';
import { MatTableDataSource } from '@angular/material/table';
import { Utils } from 'src/app/tools/utils';
import { HeaderService } from 'src/app/tools/header.service';

@Component({
  selector: 'app-products-list',
  templateUrl: './products-list.component.html',
  styleUrls: ['./products-list.component.scss']
})
export class ProductsListComponent implements OnInit {
  products: IProductV1[] = [];
  productSub: any;
  prod: IProductV1 = new IProductV1();
  prodM: IProductV1 = new IProductV1();
  selectedType: any;
  prodSub: any;
  selectedImg: File;
  selectedImgZoom: File;
  pays: any;

  productSource: any;
  displayedColumns = ["label", "price", "type", "qty", "available", "renting", "rentingFraisLiv", "picture", "edit"];

  btypeProduit: boolean = false;
  displayModalAddProduct: boolean = false;
  displayModalEditProduct: boolean = false;
  displayModalDeleteProduct: boolean = false;

  productTypes = Object.keys(ProductType).slice(Object.keys(ProductType).length / 2);
  associatedScales = Object.keys(ScaleSelect).slice(Object.keys(ScaleSelect).length / 2);
  checkScale: any = [];
  ScaleSelect = ScaleSelect;

  ProductForm = new UntypedFormGroup({
    type: new UntypedFormControl(0),
    labelP: new UntypedFormControl(''),
    labelENP: new UntypedFormControl(''),
    labelDEP: new UntypedFormControl(''),
    labelESP: new UntypedFormControl(''),
    labelITP: new UntypedFormControl(''),
    labelNLP: new UntypedFormControl(''),
    labelPLP: new UntypedFormControl(''),
    labelPTP: new UntypedFormControl(''),
    labelROP: new UntypedFormControl(''),
    labelTRP: new UntypedFormControl(''),
    fraisLivManuel: new UntypedFormControl(false),
    fraisLivP: new UntypedFormControl(0, Validators.min(0)),
    fraisLivBEP: new UntypedFormControl(0, Validators.min(0)),
    fraisLivENP: new UntypedFormControl(0, Validators.min(0)),
    fraisLivDEP: new UntypedFormControl(0, Validators.min(0)),
    fraisLivESP: new UntypedFormControl(0, Validators.min(0)),
    fraisLivITP: new UntypedFormControl(0, Validators.min(0)),
    fraisLivNLP: new UntypedFormControl(0, Validators.min(0)),
    fraisLivPLP: new UntypedFormControl(0, Validators.min(0)),
    fraisLivPTP: new UntypedFormControl(0, Validators.min(0)),
    fraisLivROP: new UntypedFormControl(0, Validators.min(0)),
    fraisLivTRP: new UntypedFormControl(0, Validators.min(0)),
    amount: new UntypedFormControl(0, [Validators.min(0.01), Validators.required]),
    qty: new UntypedFormControl(0),
    available: new UntypedFormControl(false)
  });

  constructor(private apiService: IxellAPIService, private errorService: ErrorService, private headerService: HeaderService) { }

  ngOnInit() {
    Utils.deleteStorageData();
    this.productSub = this.apiService.selectProductsAdmin().subscribe(data => {
      this.products = data;
      this.productSource = new MatTableDataSource(data);
    }, error => {
      if (this.productSub != null) this.productSub.unsubscribe();
      console.log(error);
    });
    this.headerService.changeCanBack(true);
    this.headerService.changeTitle("IxellWebLab");
    this.headerService.changeLogo(null);
  }

  openModalAddProd() {
    this.pays = "FR";
    this.prodM = new IProductV1();
    this.prodM.qteStock = 0;
    this.prodM.fraisLivP = 0;
    this.prodM.fraisLivBEP = 0;
    this.prodM.fraisLivENP = 0;
    this.prodM.fraisLivDEP = 0;
    this.prodM.fraisLivESP = 0;
    this.prodM.fraisLivITP = 0;
    this.prodM.fraisLivNLP = 0;
    this.prodM.fraisLivPLP = 0;
    this.prodM.fraisLivPTP = 0;
    this.prodM.fraisLivROP = 0;
    this.prodM.fraisLivTRP = 0;
    this.prodM.amountP = 0;

    this.checkScale = [];
    this.associatedScales.forEach(value => {
      this.checkScale.push({ name: value, check: false });
    })

    this.btypeProduit = false;
    this.ProductForm.get('qty').enable();
    this.displayModalAddProduct = true;
  }

  closeModalAddProd() {
    this.ProductForm.reset();
    this.selectedImg = null;
    this.selectedImgZoom = null;
    this.displayModalAddProduct = false;
  }

  openModalEditProd(idProd: number) {
    this.prodSub = this.apiService.getProduct(idProd)
      .subscribe(data => {
        this.prodM = new IProductV1();
        this.displayModalEditProduct = true;
        this.pays = "FR";
        this.btypeProduit = true;
        if (data.typeP == ProductType.Licence || data.fraisLivManuel) {
          this.ProductForm.patchValue({
            qty: 0,
            fraisLivP: 0,
            fraisLivBEP: 0,
            fraisLivDEP: 0,
            fraisLivENP: 0,
            fraisLivESP: 0,
            fraisLivITP: 0,
            fraisLivNLP: 0,
            fraisLivPLP: 0,
            fraisLivPTP: 0,
            fraisLivROP: 0,
            fraisLivTRP: 0
          });
          this.ProductForm.get('fraisLivP').disable();
          this.ProductForm.get('fraisLivBEP').disable();
          this.ProductForm.get('fraisLivDEP').disable();
          this.ProductForm.get('fraisLivENP').disable();
          this.ProductForm.get('fraisLivESP').disable();
          this.ProductForm.get('fraisLivITP').disable();
          this.ProductForm.get('fraisLivNLP').disable();
          this.ProductForm.get('fraisLivPLP').disable();
          this.ProductForm.get('fraisLivPTP').disable();
          this.ProductForm.get('fraisLivROP').disable();
          this.ProductForm.get('fraisLivTRP').disable();
        }
        else {
          this.ProductForm.get('fraisLivP').enable();
          this.ProductForm.get('fraisLivBEP').enable();
          this.ProductForm.get('fraisLivENP').enable();
          this.ProductForm.get('fraisLivDEP').enable();
          this.ProductForm.get('fraisLivESP').enable();
          this.ProductForm.get('fraisLivITP').enable();
          this.ProductForm.get('fraisLivNLP').enable();
          this.ProductForm.get('fraisLivPLP').enable();
          this.ProductForm.get('fraisLivPTP').enable();
          this.ProductForm.get('fraisLivROP').enable();
          this.ProductForm.get('fraisLivTRP').enable();
        }
        this.prodM = data;
        this.checkScale = [];
        this.associatedScales.forEach(value => {
          let scale = ScaleSelect[value];
          let concerned = (scale & this.prodM.associatedScale);
          this.checkScale.push({ name: value, check: (scale === concerned) });
        })
        this.ProductForm.setValue({
          type: this.prodM.typeP ? ProductType[this.prodM.typeP] : null,

          labelP: this.prodM.labelP,
          labelENP: this.prodM.labelENP,
          labelDEP: this.prodM.labelDEP,
          labelESP: this.prodM.labelESP,
          labelITP: this.prodM.labelITP,
          labelNLP: this.prodM.labelNLP,
          labelPLP: this.prodM.labelPLP,
          labelPTP: this.prodM.labelPTP,
          labelROP: this.prodM.labelROP,
          labelTRP: this.prodM.labelTRP,

          fraisLivManuel: this.prodM.fraisLivManuel,
          fraisLivP: this.prodM.fraisLivP,
          fraisLivBEP: this.prodM.fraisLivBEP,
          fraisLivENP: this.prodM.fraisLivENP,
          fraisLivDEP: this.prodM.fraisLivDEP,
          fraisLivESP: this.prodM.fraisLivESP,
          fraisLivITP: this.prodM.fraisLivITP,
          fraisLivNLP: this.prodM.fraisLivNLP,
          fraisLivPLP: this.prodM.fraisLivPLP,
          fraisLivPTP: this.prodM.fraisLivPTP,
          fraisLivROP: this.prodM.fraisLivROP,
          fraisLivTRP: this.prodM.fraisLivTRP,

          amount: this.prodM.amountP,
          qty: this.prodM.qteStock,
          available: this.prodM.available
        });
        this.ProductForm.updateValueAndValidity();
        if (this.prodSub != null) this.prodSub.unsubscribe();
      }, error => {
        if (this.prodSub != null) this.prodSub.unsubscribe();
        this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "getProduct idProduit  = " + idProd, new Date().toString());
        console.log(error);
      });
  }

  closeModalEditProd() {
    this.ProductForm.reset();
    this.selectedImg = null;
    this.selectedImgZoom = null;
    this.displayModalEditProduct = false;
  }

  addProduct() {
    this.prod = new IProductV1();
    let type: any = ProductType[this.ProductForm.value["type"]];
    this.prod.typeP = (type as ProductType);

    this.prod.labelP = this.ProductForm.value["labelP"];
    this.prod.labelENP = this.ProductForm.value["labelENP"];
    this.prod.labelDEP = this.ProductForm.value["labelDEP"];
    this.prod.labelESP = this.ProductForm.value["labelESP"];
    this.prod.labelITP = this.ProductForm.value["labelITP"];
    this.prod.labelNLP = this.ProductForm.value["labelNLP"];
    this.prod.labelPLP = this.ProductForm.value["labelPLP"];
    this.prod.labelPTP = this.ProductForm.value["labelPTP"];
    this.prod.labelROP = this.ProductForm.value["labelROP"];
    this.prod.labelTRP = this.ProductForm.value["labelTRP"];

    this.prod.fraisLivManuel = this.ProductForm.value["fraisLivManuel"] ? this.ProductForm.value["fraisLivManuel"] : false;
    this.prod.fraisLivP = this.ProductForm.value["fraisLivP"] ? this.ProductForm.value["fraisLivP"] : this.prodM.fraisLivP;
    this.prod.fraisLivBEP = this.ProductForm.value["fraisLivBEP"] ? this.ProductForm.value["fraisLivBEP"] : this.prodM.fraisLivBEP;
    this.prod.fraisLivENP = this.ProductForm.value["fraisLivENP"] ? this.ProductForm.value["fraisLivENP"] : this.prodM.fraisLivENP;
    this.prod.fraisLivDEP = this.ProductForm.value["fraisLivDEP"] ? this.ProductForm.value["fraisLivDEP"] : this.prodM.fraisLivDEP;
    this.prod.fraisLivESP = this.ProductForm.value["fraisLivESP"] ? this.ProductForm.value["fraisLivESP"] : this.prodM.fraisLivESP;
    this.prod.fraisLivITP = this.ProductForm.value["fraisLivITP"] ? this.ProductForm.value["fraisLivITP"] : this.prodM.fraisLivITP;
    this.prod.fraisLivNLP = this.ProductForm.value["fraisLivNLP"] ? this.ProductForm.value["fraisLivNLP"] : this.prodM.fraisLivNLP;
    this.prod.fraisLivPLP = this.ProductForm.value["fraisLivPLP"] ? this.ProductForm.value["fraisLivPLP"] : this.prodM.fraisLivPLP;
    this.prod.fraisLivPTP = this.ProductForm.value["fraisLivPTP"] ? this.ProductForm.value["fraisLivPTP"] : this.prodM.fraisLivPTP;
    this.prod.fraisLivROP = this.ProductForm.value["fraisLivROP"] ? this.ProductForm.value["fraisLivROP"] : this.prodM.fraisLivROP;
    this.prod.fraisLivTRP = this.ProductForm.value["fraisLivTRP"] ? this.ProductForm.value["fraisLivTRP"] : this.prodM.fraisLivTRP;

    this.prod.associatedScale = 0 as ScaleSelect;
    this.associatedScales.forEach(value => {
      if (document.getElementById(value).classList.contains("mat-mdc-checkbox-checked")) {
        this.prod.associatedScale += ScaleSelect[value];
      }
    })
    this.prod.amountP = this.ProductForm.value["amount"];

    if (this.ProductForm.value["qty"])
      this.prod.qteStock = this.ProductForm.value["qty"];
    else
      this.prod.qteStock = 0;
    this.prod.available = this.ProductForm.value["available"];

    getImageUrl(this.selectedImg, 800).then(data => {
      this.prod.picture = this.selectedImg.name;
      this.prod.pictureBlob = data;
      if (this.selectedImgZoom != null) {
        getImageUrl(this.selectedImgZoom, 800).then(dataZ => {
          this.prod.pictureZoom = this.selectedImgZoom.name;
          this.prod.pictureZoomInsertBlob = dataZ;
          this.apiService.addProduct(this.prod)
            .subscribe(id => {
              if (id > 0) {
                this.prod.productID = id;
                this.prod.pictureBlob2 = data.split(",")[1];
                this.prod.pictureZoomDisplayBlob = dataZ.split(",")[1];
                this.products.push(this.prod);

                this.productSource = new MatTableDataSource(this.products);
                this.closeModalAddProd();
                this.selectedImg = null;
                this.selectedImgZoom = null;
              }
            },
              error => {
                this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "addProduct", new Date().toString());
                console.log(error);
              });
        })
      }
      else {
        this.apiService.addProduct(this.prod)
          .subscribe(id => {
            if (id > 0) {
              this.prod.productID = id;
              this.prod.pictureBlob2 = data.split(",")[1];
              this.products.push(this.prod);

              this.productSource = new MatTableDataSource(this.products);
              this.closeModalAddProd();
              this.selectedImg = null;
            }
          },
            error => {
              this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "addProduct", new Date().toString());
              console.log(error);
            });
      }

    });
  }

  deleteProduct() {
    this.apiService.deleteProduct(this.prod.productID)
      .subscribe(resp => {
        if (resp) {
          window.location.reload();
        }
      }, error => {
        console.log(error);
        this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "deleteProduct", new Date().toString());
      });;
  }

  editProduct() {
    let type: any = ProductType[this.ProductForm.value["type"]];

    this.prodM.typeP = this.ProductForm.value["type"] != "" ? (type as ProductType) : this.prodM.typeP;

    this.prodM.labelP = this.ProductForm.value["labelP"] != "" ? this.ProductForm.value["labelP"] : this.prodM.labelP;
    this.prodM.labelENP = this.ProductForm.value["labelENP"] != "" ? this.ProductForm.value["labelENP"] : this.prodM.labelENP;
    this.prodM.labelDEP = this.ProductForm.value["labelDEP"] != "" ? this.ProductForm.value["labelDEP"] : this.prodM.labelDEP;
    this.prodM.labelESP = this.ProductForm.value["labelESP"] != "" ? this.ProductForm.value["labelESP"] : this.prodM.labelESP;
    this.prodM.labelITP = this.ProductForm.value["labelITP"] != "" ? this.ProductForm.value["labelITP"] : this.prodM.labelITP;
    this.prodM.labelNLP = this.ProductForm.value["labelNLP"] != "" ? this.ProductForm.value["labelNLP"] : this.prodM.labelNLP;
    this.prodM.labelPLP = this.ProductForm.value["labelPLP"] != "" ? this.ProductForm.value["labelPLP"] : this.prodM.labelPLP;
    this.prodM.labelPTP = this.ProductForm.value["labelPTP"] != "" ? this.ProductForm.value["labelPTP"] : this.prodM.labelPTP;
    this.prodM.labelROP = this.ProductForm.value["labelROP"] != "" ? this.ProductForm.value["labelROP"] : this.prodM.labelROP;
    this.prodM.labelTRP = this.ProductForm.value["labelTRP"] != "" ? this.ProductForm.value["labelTRP"] : this.prodM.labelTRP;

    this.prodM.fraisLivManuel = this.ProductForm.value["fraisLivManuel"];
    this.prodM.fraisLivP = this.ProductForm.value["fraisLivP"] != "" ? this.ProductForm.value["fraisLivP"] : this.prodM.fraisLivP;
    this.prodM.fraisLivBEP = this.ProductForm.value["fraisLivBEP"] != "" ? this.ProductForm.value["fraisLivBEP"] : this.prodM.fraisLivBEP;
    this.prodM.fraisLivENP = this.ProductForm.value["fraisLivENP"] != "" ? this.ProductForm.value["fraisLivENP"] : this.prodM.fraisLivENP;
    this.prodM.fraisLivDEP = this.ProductForm.value["fraisLivDEP"] != "" ? this.ProductForm.value["fraisLivDEP"] : this.prodM.fraisLivDEP;
    this.prodM.fraisLivESP = this.ProductForm.value["fraisLivESP"] != "" ? this.ProductForm.value["fraisLivESP"] : this.prodM.fraisLivESP;
    this.prodM.fraisLivITP = this.ProductForm.value["fraisLivITP"] != "" ? this.ProductForm.value["fraisLivITP"] : this.prodM.fraisLivITP;
    this.prodM.fraisLivNLP = this.ProductForm.value["fraisLivNLP"] != "" ? this.ProductForm.value["fraisLivNLP"] : this.prodM.fraisLivNLP;
    this.prodM.fraisLivPLP = this.ProductForm.value["fraisLivPLP"] != "" ? this.ProductForm.value["fraisLivPLP"] : this.prodM.fraisLivPLP;
    this.prodM.fraisLivPTP = this.ProductForm.value["fraisLivPTP"] != "" ? this.ProductForm.value["fraisLivPTP"] : this.prodM.fraisLivPTP;
    this.prodM.fraisLivROP = this.ProductForm.value["fraisLivROP"] != "" ? this.ProductForm.value["fraisLivROP"] : this.prodM.fraisLivROP;
    this.prodM.fraisLivTRP = this.ProductForm.value["fraisLivTRP"] != "" ? this.ProductForm.value["fraisLivTRP"] : this.prodM.fraisLivTRP;

    this.prodM.amountP = this.ProductForm.value["amount"] != "" ? this.ProductForm.value["amount"] : this.prodM.amountP;
    this.prodM.qteStock = this.ProductForm.value["qty"] != "" || this.ProductForm.value["qty"] == 0 ? this.ProductForm.value["qty"] : this.prodM.qteStock;
    this.prodM.available = this.ProductForm.value["available"];
    this.prodM.associatedScale = 0 as ScaleSelect;
    this.associatedScales.forEach(value => {
      if (document.getElementById(value).classList.contains("mat-mdc-checkbox-checked")) {
        this.prodM.associatedScale += ScaleSelect[value];
      }
    })
    let index: number = this.products.findIndex(element => element.productID == this.prodM.productID);

    this.apiService.editProduct(this.prodM)
      .subscribe(resp => {
        if (resp) {
          this.products[index] = this.prodM;
          this.productSource = new MatTableDataSource(this.products);
          this.closeModalEditProd();
          this.selectedImg = null;
          this.selectedImgZoom = null;
        }
      }, error => {
        console.log(error);
        this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "editProduct", new Date().toString());
        this.selectedImg = null;
        this.selectedImgZoom = null;
      });
  }

  openModalDeleteProd(idProd: number) {
    this.prodSub = this.apiService.getProduct(idProd)
      .subscribe(data => {
        this.prod = data;
        this.displayModalDeleteProduct = true;
        if (this.productSub != null) this.productSub.unsubscribe();
      }, error => {
        if (this.productSub != null) this.productSub.unsubscribe();
        console.log(error);
        this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "getProduct", new Date().toString());
      });
  }

  closeModalDeleteProd() {
    this.displayModalDeleteProduct = false;
  }

  /* Permet d'activer ou non le champs de qte
   * S'il s'agit d'une licence alors il n'y a pas de qte
   * il n'y a pas de frais de livraison 
   */
  changeValue(provenance: string = ""): void {
    let type = this.ProductForm.value["type"];
    if (provenance == "ProduitType") {
      this.btypeProduit = true;
    }

    if (ProductType[type] == ProductType.Licence.toString() || this.ProductForm.value["fraisLivManuel"]) {
      if (ProductType[type] == ProductType.Licence.toString()) {
        this.ProductForm.patchValue({
          fraisLivManuel: false
        });
        this.ProductForm.get('fraisLivManuel').disable();
      }
      this.ProductForm.patchValue({
        fraisLivP: 0,
        fraisLivBEP: 0,
        fraisLivENP: 0,
        fraisLivDEP: 0,
        fraisLivESP: 0,
        fraisLivITP: 0,
        fraisLivNLP: 0,
        fraisLivPLP: 0,
        fraisLivPTP: 0,
        fraisLivROP: 0,
        fraisLivTRP: 0
      });
      this.ProductForm.get('fraisLivP').disable();
      this.ProductForm.get('fraisLivBEP').disable();
      this.ProductForm.get('fraisLivENP').disable();
      this.ProductForm.get('fraisLivDEP').disable();
      this.ProductForm.get('fraisLivESP').disable();
      this.ProductForm.get('fraisLivITP').disable();
      this.ProductForm.get('fraisLivNLP').disable();
      this.ProductForm.get('fraisLivPLP').disable();
      this.ProductForm.get('fraisLivPTP').disable();
      this.ProductForm.get('fraisLivROP').disable();
      this.ProductForm.get('fraisLivTRP').disable();
    }
    else {
      this.ProductForm.get('fraisLivManuel').enable();
      this.ProductForm.get('fraisLivP').enable();
      this.ProductForm.get('fraisLivBEP').enable();
      this.ProductForm.get('fraisLivENP').enable();
      this.ProductForm.get('fraisLivDEP').enable();
      this.ProductForm.get('fraisLivESP').enable();
      this.ProductForm.get('fraisLivITP').enable();
      this.ProductForm.get('fraisLivNLP').enable();
      this.ProductForm.get('fraisLivPLP').enable();
      this.ProductForm.get('fraisLivPTP').enable();
      this.ProductForm.get('fraisLivROP').enable();
      this.ProductForm.get('fraisLivTRP').enable();
    }
  }

  changeDispo(idProd: number) {
    if (this.products.find(x => x.productID == idProd).available)
      this.products.find(x => x.productID == idProd).available = false;
    else
      this.products.find(x => x.productID == idProd).available = true;
    this.apiService.editDispoProduct(idProd, this.products.find(x => x.productID == idProd).available)
      .subscribe(resp => {
      }, error => {
        console.log(error);
        this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "changeDispo", new Date().toString());
      });
  }

  changeRentable(id: number) {
    if (this.products.find(x => x.productID == id).rentable == 1)
      this.products.find(x => x.productID == id).rentable = 0;
    else
      this.products.find(x => x.productID == id).rentable = 1;
    this.apiService.editRentableProduct(id, this.products.find(x => x.productID == id).rentable)
      .subscribe(resp => {
      }, error => {
        console.log(error);
        this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "changeRentable", new Date().toString());
      });
  }

  changeRentableFraisLiv(id: number) {
    if (this.products.find(x => x.productID == id).fraisLivRentable == 1)
      this.products.find(x => x.productID == id).fraisLivRentable = 0;
    else
      this.products.find(x => x.productID == id).fraisLivRentable = 1;

    this.apiService.editRentableFraisLiv(id, this.products.find(x => x.productID == id).rentable).subscribe(
      data => { },
      error => {
        console.log(error);
        this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "changeRentableFraisLiv", new Date().toString());
      });
  }

  onFileChanged(event: any) {
    this.selectedImg = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.onloadend = () => {
      getImageUrl(this.selectedImg, 800).then(data => {
        var base64data = reader.result as string;
        this.prodM.pictureBlob2 = base64data.substr(base64data.indexOf(',') + 1);
        this.prodM.picture = this.selectedImg.name;
        this.prodM.pictureBlob = data;
      });
    };
    reader.readAsDataURL(this.selectedImg);
  }

  onFileZoomChanged(event: any) {
    this.selectedImgZoom = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.onloadend = () => {
      getImageUrl(this.selectedImgZoom, 800).then(dataZ => {
        var base64dataZ = reader.result as string;
        this.prodM.pictureZoomDisplayBlob = base64dataZ.substr(base64dataZ.indexOf(',') + 1);
        this.prodM.pictureZoom = this.selectedImgZoom.name;
        this.prodM.pictureZoomInsertBlob = dataZ;
      });
    };
    reader.readAsDataURL(this.selectedImgZoom);
  }
}
